import React, {useState, useEffect} from 'react';
import SystemRoleWizardBody from './SystemRoleWizardBody';
import Api from '../../../api/SMPFetchHelper';
import {ObjectTypes} from '../../../api/consts';
import {useSMCErrorHandler} from '../../../utils/errorUtils';
import SMCModal from '../../../components/core/SMCModal';
import {useTranslation} from 'react-i18next';
import {SystemRoleCreateSchema} from '../../../api/DBSchema/SystemRole';
import {useIsMountedRef} from '../../../utils/hooks';

function SystemRoleWizard({
    isOpen,
    onRequestClose,
    onSuccess
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();
    const isMountedRef = useIsMountedRef();

    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    const onFinish = async () => {
        const createSystemRoleRequestObj = {
            [SystemRoleCreateSchema.name]: name,
            [SystemRoleCreateSchema.description]: description,
        }
        setIsLoading(true);
        Api.createObject(ObjectTypes.SYSTEM_ROLE, createSystemRoleRequestObj)
        .then(() => {
            if (isMountedRef.current) {
                onSuccess(name);
            }
        })
        .catch (e => {
            if (isMountedRef.current) {
                const errorMessage = getErrorMessage(e);
                alert(errorMessage);
            }
        }).finally(() => {
            if (isMountedRef.current) {
                setIsLoading(false);
            }
        });
    }

    // Reset to defaults on every open
    useEffect(() => {
        if (isOpen) {
            setName('');
            setDescription('');
        }
    }, [isOpen]);

    const wizardVars = {
        name, setName,
        description, setDescription,
    }

    return (
        <SMCModal
            title={t('SMP.SYSTEM_ROLES.NEW_ROLE_WIZ.CREATE_NEW')}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            width={610}
            height={600}
            loading={isLoading}
        >
            <SystemRoleWizardBody
                onFinish={onFinish}
                onCancel={onRequestClose}
                wizardVars={wizardVars}
            />
        </SMCModal>
    );
}

export default SystemRoleWizard;